var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDevelopment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 6.25V12.5H6.75V6.25H13ZM3.625 3.125V15.625H16.125V3.125H3.625ZM28.625 10.9375V17.1875H22.375V10.9375H28.625ZM19.25 7.8125V20.3125H31.75V7.8125H19.25ZM13 25V31.25H6.75V25H13ZM3.625 21.875V34.375H16.125V21.875H3.625Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.875 15.625V25H25.5V34.375H16.125V46.875H47.375V15.625H34.875ZM28.625 28.125H34.875V34.375H28.625V28.125ZM25.5 43.75H19.25V37.5H25.5V43.75ZM34.875 43.75H28.625V37.5H34.875V43.75ZM44.25 43.75H38V37.5H44.25V43.75ZM44.25 34.375H38V28.125H44.25V34.375ZM38 25V18.75H44.25V25H38Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopment);
export default __webpack_public_path__ + "static/media/development.a4763a4d572e8b3b8f598658583d537a.svg";
export { ForwardRef as ReactComponent };